import { jUserId, hUserId } from "./data-v2";

export type PensionScheme = "net-pay" | "relief-at-source" | "salary-sacrifice";

export type UserProfile = {
  id: string;
  country: "rUK" | "scotland";
  taxCode: string | null;
  pension: {
    contributionRate: number | null; // e.g. 0.05 for 5%
    scheme: PensionScheme | null;
  } | null;
  studentLoan: {
    plan: 1 | 2 | 4 | 5 | null;
    postgraduate: boolean | null;
  } | null;
};

const defaultProfile: UserProfile = {
  id: "unknown",
  country: "rUK",
  taxCode: "1257L",
  pension: {
    contributionRate: 0.05,
    scheme: "salary-sacrifice",
  },
  studentLoan: {
    plan: null,
    postgraduate: false,
  },
};

const profilesById: Record<string, UserProfile> = {
  [jUserId]: {
    ...defaultProfile,
    id: jUserId,
  },
  [hUserId]: {
    ...defaultProfile,
    id: hUserId,
  },
};

export function getUserProfile(userId: string): UserProfile {
  return profilesById[userId] ?? { ...defaultProfile, id: userId };
}
